import React from 'react';
import PropTypes from 'prop-types';
import addContext from './addContext';

export default function addD2Context(Component) {
    return addContext(Component, { d2: PropTypes.object });
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/component-helpers/addD2Context.js
// module id = 60
// module chunks = 13